<template>
  <ul :class="{'list01-list': model.id === 0}">
    <li :class="{'list01-item': (model.id !== 0), 'list01-item': (model.id !== 0), 'is-parent': group1.isParent, 'is-open': group1.isOpen}">
      <div v-if="model.id !== 0" class="label">
        <div class="formparts checkbox">
          <input type="checkbox"
            :id="'package_product_' + model.itemType + '_' + model.id"
            @change="group1.itemClicked(model)"
            v-model="group1.isChecked">
          <label :for="'package_product_' + model.itemType + '_' + model.id"
            >{{ model.name }} <span v-if="group1.isSearchCountShown">({{ group1.search_count_disp }})</span><FontawesomeIcon icon="check" class="icn" /></label>
        </div>
      </div>
      <template v-if="group1.isOpen && group1.isFolder">
        <SPPackageAndProductsTreeItem 
          v-for="model2 in group1.children"
          :model="model2"
          :key="'package_and_producrs_' + model2.itemType + '_' + model2.id"
          :isSearchCountShown="group1.isSearchCountShown"
          :isSearchDetail="group1.isSearchDetail"
          @emitItemClicked="group1.emitItemClicked"
        />
      </template>
    </li>
  </ul>
</template>

<script>
// パッケージ＆商品一覧ツリー生成用コンポーネント
import { ref, reactive, computed, watch, defineComponent, onMounted } from '@vue/composition-api'
import SPPackageAndProductsTreeItem from '@/components/sp/partial/qa/SPPackageAndProductsTreeItem'
import * as logicPackageAndProductsTreeItem from '@/logic/qa/PackageAndProductsTreeItem'

export default defineComponent({
  name: 'SPPackageAndProductsTreeItem',
  components: {
    SPPackageAndProductsTreeItem
  },
  props: {
    model: {
      type: Object,
      required: true
    },
    // ヒット件数表示フラグ
    isSearchCountShown: {
      type: Boolean,
      required: false,
      default: false
    },
    // 詳細検索実行中フラグ
    isSearchDetail: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup (props, context) {

    onMounted(() => {
      group1.init()
    })

    const group1 = logicPackageAndProductsTreeItem.getGroup(props, context)

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
</style>
